import React from "react";

const SectionEyebrow = ({ icon: Icon, children, center = false }) => (
  <p
    className={[
      "inline-flex items-center gap-2 text-[13px] font-bold text-[var(--land-primary)] uppercase tracking-[.1em] mb-3.5",
      "before:content-[''] before:w-6 before:h-0.5 before:bg-[var(--land-primary)] before:rounded-sm",
      center ? "after:content-[''] after:w-6 after:h-0.5 after:bg-[var(--land-primary)] after:rounded-sm" : "",
    ].join(" ")}
  >
    {Icon && <Icon size={14} />}
    {children}
  </p>
);

export default SectionEyebrow;
